import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from "../images/logo.png"
import { scroller } from 'react-scroll';
import { useLocation } from "react-router-dom"

function Navbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const stateData = location.state;
  
  const scrollToElement = (elementName) => {
    scroller.scrollTo(elementName, {
      smooth: true,
      duration: 500,
      offset: -80,
    });
  };
  
  useEffect(() => {
    if (stateData) {
      scrollToElement(stateData);
    }
  }, [stateData]);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'experience', 'projects', 'skills', 'education', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.querySelector(`[name="${sections[i]}"]`);
        if (section) {
          const offsetTop = section.offsetTop;
          if (scrollPosition >= offsetTop) {
            setActiveSection(sections[i]);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

  const handleNavClick = (section) => {
    setActiveSection(section);
    toggleNav();
  };
  

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <img src={logo} alt='Vignesh M Logo' />
        </div>
        <button 
          className="navbar-icon" 
          onClick={toggleNav}
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
        <ul className={`navbar-menu ${isOpen ? 'open' : ''}`}>
          <li><Link className={`nav-item ${activeSection === 'home' ? 'active' : ''}`} to='home' smooth={true} duration={500} offset={-80} onClick={() => handleNavClick('home')}>Home</Link></li>
          <li><Link className={`nav-item ${activeSection === 'about' ? 'active' : ''}`} to="about" smooth={true} duration={500} offset={-80} onClick={() => handleNavClick('about')}>About</Link></li>
          <li><Link className={`nav-item ${activeSection === 'experience' ? 'active' : ''}`} to="experience" smooth={true} duration={500} offset={-80} onClick={() => handleNavClick('experience')}>Experience</Link></li>
          <li><Link className={`nav-item ${activeSection === 'projects' ? 'active' : ''}`} to="projects" smooth={true} duration={500} offset={-80} onClick={() => handleNavClick('projects')}>Projects</Link></li>
          <li><Link className={`nav-item ${activeSection === 'skills' ? 'active' : ''}`} to="skills" smooth={true} duration={500} offset={-80} onClick={() => handleNavClick('skills')}>Skills</Link></li>
          <li><Link className={`nav-item ${activeSection === 'education' ? 'active' : ''}`} to="education" smooth={true} duration={500} offset={-80} onClick={() => handleNavClick('education')}>Education</Link></li>
          <li><Link className={`nav-item ${activeSection === 'contact' ? 'active' : ''}`} to="contact" smooth={true} duration={500} offset={-80} onClick={() => handleNavClick('contact')}>Contact</Link></li>
          <li>
          </li>
        </ul>
        
      </div>
    </nav>
  );
}

export default Navbar;
